<template>
    <body>
    <div class="bgimg-1">
        <div class="caption">
            <span class="border">Business use cases</span><br>
            <span class="border">PET SITTER</span>
        </div>
    </div>

    <div class="features">
        <h3 style="text-align:center;">SaPPo Features</h3>
        <div >
            <i class="fa fa-calendar" aria-hidden="true"></i> View live / history appointments <br>
            <i class="fa fa-check" aria-hidden="true"></i> Confirm/Reject appointments<br>
            <i class="fa fa-map-marker" aria-hidden="true"></i> Create from one to multiple offices(locations)<br>
            <i class="fa fa-hourglass" aria-hidden="true"></i> Set open/close & slot time schedule by office(location)<br>
        </div>
    </div>

    <div class="bgimg-2">
        <div class="caption">
            <span class="border" >MEDICAL OFFICES</span>
        </div>
    </div>

    <div style="position:relative;">
        <div class="text_msg">
            <p><i class="fa fa-eur" aria-hidden="true"></i>
                Dedicated to Small businesses at low cost: {{getBusinessPrice}}
                <i class="fa fa-eur" aria-hidden="true"></i> / month
            </p>
        </div>
    </div>

    <div class="bgimg-3">
        <div class="caption">
            <span class="border">BEAUTY SALONS</span>
        </div>
    </div>

    <div style="position:relative;">
        <div class="text_msg">
            <p><i class="fa fa-qrcode" aria-hidden="true"></i> Easy access for your business customers.</p>
        </div>
    </div>

    <div class="bgimg-4">
        <div class="caption">
            <span class="border">ADMINISTRATIVE DOCUMENTS</span>
        </div>
    </div>

    <div style="position:relative;">
        <div class="text_msg">
            <p><i class="fa fa-laptop" aria-hidden="true"></i> No hardware or software to buy and maintenance.</p>
        </div>
    </div>

    <div class="bgimg-1">
        <div class="caption">
            <span class="border">PET GROOMING</span>
        </div>
    </div>
    </body>
</template>
<script>
    export default {
        name:'HelloBusiness',
        data(){
            return {

            }
        },
        computed: {
            getBusinessPrice() {
                return this.$store.getters.getPricePerMonth
            }
        }
    }
</script>
<style lang="scss" scoped>
    body, html {
        height: 100%;
        margin: 0;
        font: 400 15px/1.8 "Lato", sans-serif;
        color: #777;
    }

    .bgimg-1, .bgimg-2, .bgimg-3, .bgimg-4 {
        position: relative;
        opacity: 0.85;
        background-position: center;
        background-size: cover;
        /* Create the parallax scrolling effect */
        background-attachment: fixed;
        /*background-position: center;*/
        background-repeat: no-repeat;
        /*background-size: cover;*/

    }
    .bgimg-1 {
        background-image: url("../assets/pet_grooming_img (62).jpeg");
        //url("https://mdbootstrap.com/img/Photos/Slides/img%20(62).jpg");
        min-height: 100%;
    }

    .bgimg-2 {
        background-image: url("../assets/medical_img (93).jpeg");
        //url("https://mdbootstrap.com/img/Photos/Slides/img%20(93).jpg");
        min-height: 400px;
    }

    .bgimg-3 {
        background-image: url("../assets/cosmetics_img (37).jpeg");
        //url("https://mdbootstrap.com/img/Photos/Slides/img%20(37).jpg");
        min-height: 400px;
    }

    .bgimg-4 {
        background-image: url("../assets/admin_img (90).jpeg");
        //url("https://mdbootstrap.com/img/Photos/Slides/img%20(37).jpg");
        min-height: 400px;
    }

    .caption {
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        text-align: center;
        color: #000;
    }

    .caption span.border {
        //background-color: black;
        color: #fff;
        padding: 18px;
        font-size: 25px;
        letter-spacing: 10px;
    }

    .text_msg {
        color:#ddd;
        background-color:#282E34;
        text-align:center;
        padding:50px 80px;
    }

    h3 {
        letter-spacing: 5px;
        text-transform: uppercase;
        font: 20px "Lato", sans-serif;
        color: #111;
    }
    .features {
        color: #777;
        background-color:white;
        text-align:justify;
        padding:50px 80px;
        font-size: 15px;
    }

    @media screen and (max-width: 600px) {
        h3 {
            font-size: 12px;
        }
        .caption {
            top: 80%;
        }
        .caption span.border {
            font-size: 15px;
        }
        .features {
            padding: 30px 20px;
            font-size: 10px;
        }
        .text_msg {
            font-size: 12px;
            padding: 30px 10px;
        }

        .bgimg-1 {
            //background-size: contain;
            background-attachment: scroll;
        }
        .bgimg-2 {
            //background-size: contain;
            background-attachment: scroll;
        }
        .bgimg-3 {
            //background-size: contain;
            background-attachment: scroll;
        }
        .bgimg-4 {
            //background-size: contain;
            background-attachment: scroll;
        }
    }
</style>